@if (isLoggedIn) {
<div>
  <p-tabView #tabview [(activeIndex)]="activeIndex" (onChange)="onTabChange($event)">
    @if (isAdmin) {
    <p-tabPanel header="Users" headerStyleClass="config-tab">
      <user-list></user-list>
    </p-tabPanel>
    }
    @if (isAdmin) {
    <p-tabPanel header="Groups" headerStyleClass="config-tab">
      <group-list></group-list>
    </p-tabPanel>
    }
    @if (isAdmin) {
    <p-tabPanel header="Authentication Settings" headerStyleClass="config-tab">
      <auth-settings></auth-settings>
    </p-tabPanel>
    }
    @if (isAdmin) {
    <p-tabPanel header="License" headerStyleClass="config-tab">
      <license-manager></license-manager>
    </p-tabPanel>
    }
    @if (isAdmin) {
    <p-tabPanel header="Credentials" headerStyleClass="config-tab">
      <copy-credentials></copy-credentials>
    </p-tabPanel>
    }
    @if (isAdmin) {
    <p-tabPanel header="Audit Log" headerStyleClass="config-tab">
      <audit-log></audit-log>
    </p-tabPanel>
    }
    @if (isAdmin) {
    <p-tabPanel header="Admin Reports" headerStyleClass="config-tab">
      <admin-reports></admin-reports>
    </p-tabPanel>
    }
    @if (isAdmin) {
    <p-tabPanel header="Integration Settings" headerStyleClass="config-tab">
      <integration-settings></integration-settings>
    </p-tabPanel>
    }
    @if (isAdmin) {
    <p-tabPanel header="Server Settings" headerStyleClass="config-tab">
      <server-settings></server-settings>
    </p-tabPanel>
    }
    <!--
      <p-tabPanel *ngIf="isAdmin" header="Linked Servers" headerStyleClass="config-tab">
        <linked-servers></linked-servers>
      </p-tabPanel> -->
  </p-tabView>
</div>
}